import { Tab as MUITab, styled } from '@mui/material';
const Tab = styled(MUITab)(({ theme }) => {
    return {
        color: '#B2B2B2',
        fontSize: theme.typography['uikit-subheader3'].fontSize,
        fontWeight: theme.typography['uikit-subheader3'].fontWeight,
        lineHeight: theme.typography['uikit-subheader3'].lineHeight,
        minWidth: 'unset',
        paddingInline: 0,
        textTransform: 'none',
    };
});
export default Tab;
